/* DZ Bewertungen (Runde 59)

   Holt die Bewertungen aus dem App-Proxy von Sternify und baut die
   Karten selbst. Kein fremdes Skript auf der Seite, solange niemand
   "Bewertung schreiben" drueckt.

   Geladen wird erst in Sichtweite (IntersectionObserver, 400 px
   Vorlauf). Geht etwas schief, verschwindet die Sektion still -
   eine Fehlermeldung waere hier fuer niemanden nuetzlich.

   Die Texte kommen von aussen und werden deshalb ausschliesslich
   ueber textContent gesetzt, nie ueber innerHTML. */

(function () {
  'use strict';

  var STERN_VOLL =
    '<svg viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">' +
    '<path d="M10 1.6l2.47 5.28 5.53.72-4.06 3.9 1.03 5.7L10 14.5l-4.97 2.7 1.03-5.7L2 7.6l5.53-.72z"/></svg>';

  function sterne(anzahl, gesamt) {
    // Ganze Sterne in Gold, der Rest in Grau. Halbe Sterne zeichnen wir
    // nicht - die Zahl daneben ist genauer als ein angeschnittenes Bild.
    var voll = Math.round(anzahl);
    var raus = '';
    for (var i = 1; i <= (gesamt || 5); i++) {
      raus += '<span style="color:' + (i <= voll ? 'var(--dz-bw-stern)' : 'var(--dz-bw-rand)') + '">' +
        STERN_VOLL + '</span>';
    }
    return raus;
  }

  function nameKurz(voll) {
    // "Omar Hassan" -> "Omar H."   "Tim" -> "Tim"
    var teile = String(voll || '').trim().split(/\s+/).filter(Boolean);
    if (!teile.length) return 'Anonym';
    if (teile.length === 1) return teile[0];
    return teile[0] + ' ' + teile[teile.length - 1].charAt(0).toUpperCase() + '.';
  }

  function datum(iso) {
    var d = new Date(iso);
    if (isNaN(d.getTime())) return '';
    var z = function (n) { return n < 10 ? '0' + n : String(n); };
    return z(d.getDate()) + '.' + z(d.getMonth() + 1) + '.' + d.getFullYear();
  }

  function bilder(eintrag) {
    if (!Array.isArray(eintrag.media)) return [];
    return eintrag.media.filter(function (m) {
      return m && m.type === 'image' && m.url && m.status !== 'hidden';
    });
  }

  // ---------- Lightbox ----------

  function lupeOeffnen(url) {
    var lupe = document.createElement('div');
    lupe.className = 'dz-bw__lupe';
    lupe.setAttribute('role', 'dialog');
    lupe.setAttribute('aria-modal', 'true');
    lupe.setAttribute('aria-label', 'Bild zur Bewertung');

    var bild = new Image();
    bild.src = url;
    bild.alt = '';
    lupe.appendChild(bild);

    var zu = document.createElement('button');
    zu.type = 'button';
    zu.className = 'dz-bw__lupe-zu';
    zu.setAttribute('aria-label', 'Schließen');
    zu.textContent = '×';
    lupe.appendChild(zu);

    function schliessen() {
      document.removeEventListener('keydown', taste);
      lupe.remove();
      document.body.style.overflow = vorher;
    }
    function taste(e) { if (e.key === 'Escape') schliessen(); }

    // Ein Tipp irgendwohin schliesst - auch auf dem Telefon, wo der
    // kleine Knopf schwer zu treffen ist.
    lupe.addEventListener('click', schliessen);
    document.addEventListener('keydown', taste);

    var vorher = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    document.body.appendChild(lupe);
    zu.focus();
  }

  // ---------- Karte ----------

  function karte(eintrag) {
    var k = document.createElement('article');
    k.className = 'dz-bw__karte';
    k.setAttribute('role', 'listitem');

    var st = document.createElement('span');
    st.className = 'dz-bw__kartensterne';
    st.setAttribute('role', 'img');
    st.setAttribute('aria-label', eintrag.rating + ' von 5 Sternen');
    st.innerHTML = sterne(eintrag.rating);
    k.appendChild(st);

    if (eintrag.title) {
      var t = document.createElement('h3');
      t.className = 'dz-bw__kartentitel';
      t.textContent = eintrag.title;
      k.appendChild(t);
    }

    var text = document.createElement('p');
    text.className = 'dz-bw__text';
    text.textContent = eintrag.content || '';
    k.appendChild(text);

    // "Mehr lesen" nur, wenn der Text wirklich abgeschnitten ist.
    // Das laesst sich erst nach dem Einhaengen messen, siehe unten.
    var mehr = document.createElement('button');
    mehr.type = 'button';
    mehr.className = 'dz-bw__mehrlesen';
    mehr.textContent = 'Mehr lesen';
    mehr.hidden = true;
    mehr.addEventListener('click', function () {
      text.classList.add('dz-bw__text--offen');
      mehr.hidden = true;
    });
    k.appendChild(mehr);
    k._dzText = text;
    k._dzMehr = mehr;

    var bs = bilder(eintrag);
    if (bs.length) {
      var reihe = document.createElement('div');
      reihe.className = 'dz-bw__bilder';
      bs.slice(0, 3).forEach(function (m) {
        var knopf = document.createElement('button');
        knopf.type = 'button';
        knopf.className = 'dz-bw__bild';
        knopf.setAttribute('aria-label', 'Bild vergrößern');
        var img = new Image();
        img.src = m.url;
        img.alt = '';
        img.loading = 'lazy';
        knopf.appendChild(img);
        knopf.addEventListener('click', function () { lupeOeffnen(m.url); });
        reihe.appendChild(knopf);
      });
      k.appendChild(reihe);
    }

    var fuss = document.createElement('div');
    fuss.className = 'dz-bw__fuss';

    var links = document.createElement('span');
    var name = document.createElement('span');
    name.className = 'dz-bw__name';
    name.textContent = nameKurz(eintrag.name);
    links.appendChild(name);
    var d = datum(eintrag.date);
    if (d) links.appendChild(document.createTextNode(' · ' + d));
    fuss.appendChild(links);

    if (eintrag.verified) {
      var geprueft = document.createElement('span');
      geprueft.className = 'dz-bw__geprueft';
      geprueft.innerHTML =
        '<svg viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="2" ' +
        'stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' +
        '<path d="M13.5 4.5L6.5 11.5 2.5 7.5"/></svg>';
      geprueft.appendChild(document.createTextNode('Verifizierter Kauf'));
      fuss.appendChild(geprueft);
    }

    k.appendChild(fuss);
    return k;
  }

  // ---------- Formular ----------

  // Sternifys Formular-Modul nachladen - erst beim Klick.
  //
  // Nicht ueber import() im Quelltext: Shopify schickt Theme-JS durch
  // einen Bundler, der ein woertliches import( ) zu require( ) umbaut;
  // im Browser gibt es kein require, der Aufruf scheitert also immer.
  // Ein eingehaengtes <script type="module"> geht diesen Weg nicht,
  // weil der Importbefehl hier nur als Zeichenkette dasteht.
  function modulLaden(url) {
    return new Promise(function (fertig, scheitern) {
      if (window.__dzPopupModul) { fertig(window.__dzPopupModul); return; }
      var zeit = setTimeout(function () { scheitern(new Error('Zeit abgelaufen')); }, 8000);
      window.addEventListener('dz-popup-bereit', function () {
        clearTimeout(zeit);
        fertig(window.__dzPopupModul);
      }, { once: true });
      var s = document.createElement('script');
      s.type = 'module';
      s.textContent =
        'import * as m from ' + JSON.stringify(url) + ';' +
        'window.__dzPopupModul = m;' +
        'window.dispatchEvent(new Event("dz-popup-bereit"));';
      s.onerror = function () { clearTimeout(zeit); scheitern(new Error('Modul nicht ladbar')); };
      document.head.appendChild(s);
    });
  }

  function formularOeffnen(wurzel, knopf) {
    var produkt = wurzel.dataset.produkt || '';
    var modul = wurzel.dataset.modul || '';
    knopf.setAttribute('aria-busy', 'true');

    var fertig = function () { knopf.removeAttribute('aria-busy'); };

    // openReviewPopup oeffnet sofort - createProductReviewPopup wuerde
    // nur einen Klick-Horcher anhaengen und einen zweiten Klick verlangen.
    modulLaden(modul)
      .then(function (m) {
        m.openReviewPopup(produkt || null);
        fertig();
      })
      .catch(function (fehler) {
        if (window.console) console.warn('[dz-bw] Sternify-Modul nicht erreichbar:', fehler);
        eigenesOverlay(produkt);
        fertig();
      });
  }

  function eigenesOverlay(produkt) {
    // Rueckfall, falls die Moduladresse nach einem App-Update nicht
    // mehr stimmt. Dieselbe Proxy-Adresse, die Sternify selbst baut.
    var daten = { popup: true, origin: window.location.origin };
    if (produkt) daten.product = Number(produkt);
    var kodiert = btoa(JSON.stringify(daten));

    var huelle = document.createElement('div');
    huelle.style.cssText =
      'position:fixed;inset:0;z-index:10001;background:rgba(0,0,0,.4);';
    var rahmen = document.createElement('iframe');
    rahmen.src = '/apps/sternify/leave-review/' + kodiert;
    rahmen.title = 'Bewertung schreiben';
    rahmen.style.cssText = 'width:100%;height:100%;border:0;';
    huelle.appendChild(rahmen);

    function schliessen() {
      window.removeEventListener('message', horcher);
      document.removeEventListener('keydown', taste);
      huelle.remove();
      document.body.style.overflow = vorher;
    }
    function taste(e) { if (e.key === 'Escape') schliessen(); }
    function horcher(e) {
      if (e.source === rahmen.contentWindow && e.data && e.data.type === 'close-modal') schliessen();
    }

    var vorher = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    window.addEventListener('message', horcher);
    document.addEventListener('keydown', taste);
    document.body.appendChild(huelle);
  }

  // ---------- Aufbau ----------

  function aufbauen(wurzel, daten) {
    var min = parseInt(wurzel.dataset.minSterne, 10) || 4;
    var schritt = parseInt(wurzel.dataset.schritt, 10) || 6;
    var alle = Array.isArray(daten.reviews) ? daten.reviews : [];

    var liste = alle.filter(function (r) {
      return r && r.approved !== false && Number(r.rating) >= min;
    });

    // Angeheftet zuerst, dann Bewertungen mit Bild, dann die neuesten.
    liste.sort(function (a, b) {
      var ap = a.pinned ? 1 : 0, bp = b.pinned ? 1 : 0;
      if (ap !== bp) return bp - ap;
      var ab = bilder(a).length ? 1 : 0, bb = bilder(b).length ? 1 : 0;
      if (ab !== bb) return bb - ab;
      return new Date(b.date) - new Date(a.date);
    });

    if (!liste.length) { wurzel.hidden = true; return; }

    // Kopfzahlen: so, wie Sternify sie liefert - ueber ALLE Bewertungen,
    // nicht ueber die gefilterte Liste.
    var note = Number(daten.storeRating || 0);
    var gesamt = Number(daten.totalCount || alle.length);
    if (note > 0) {
      wurzel.querySelector('[data-dz-note]').textContent =
        note.toFixed(1).replace('.', ',') + ' / 5,0';
      wurzel.querySelector('[data-dz-kopfsterne]').innerHTML = sterne(note);
      wurzel.querySelector('[data-dz-anzahl]').textContent = 'aus ' + gesamt + ' Bewertungen';
    }

    var behaelter = wurzel.querySelector('[data-dz-liste]');
    behaelter.textContent = '';
    var karten = liste.map(function (r) {
      var k = karte(r);
      behaelter.appendChild(k);
      return k;
    });

    // Jetzt haengen die Karten - erst jetzt laesst sich messen, ob der
    // Text ueber vier Zeilen hinausgeht.
    karten.forEach(function (k) {
      if (k._dzText.scrollHeight - k._dzText.clientHeight > 2) k._dzMehr.hidden = false;
    });

    var sichtbar = schritt;
    var mehrKnopf = wurzel.querySelector('[data-dz-mehr]');
    function zeigen() {
      karten.forEach(function (k, i) {
        if (i < sichtbar) k.removeAttribute('data-versteckt');
        else k.setAttribute('data-versteckt', '1');
      });
      mehrKnopf.hidden = sichtbar >= karten.length;
    }
    mehrKnopf.addEventListener('click', function () {
      sichtbar += schritt;
      zeigen();
    });
    zeigen();
  }

  function laden(wurzel) {
    fetch(wurzel.dataset.endpunkt, { headers: { accept: 'application/json' } })
      .then(function (a) {
        if (!a.ok) throw new Error(a.status);
        return a.json();
      })
      .then(function (daten) { aufbauen(wurzel, daten); })
      .catch(function () { wurzel.hidden = true; });
  }

  function start(wurzel) {
    if (wurzel.dataset.dzBereit) return;
    wurzel.dataset.dzBereit = '1';

    var knopf = wurzel.querySelector('[data-dz-schreiben]');
    if (knopf) {
      knopf.addEventListener('click', function () { formularOeffnen(wurzel, knopf); });
    }

    if (!('IntersectionObserver' in window)) { laden(wurzel); return; }
    var beobachter = new IntersectionObserver(function (eintraege) {
      eintraege.forEach(function (e) {
        if (!e.isIntersecting) return;
        beobachter.disconnect();
        laden(wurzel);
      });
    }, { rootMargin: '400px 0px' });
    beobachter.observe(wurzel);
  }

  function alleStarten() {
    document.querySelectorAll('[data-dz-bewertungen]').forEach(start);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', alleStarten);
  } else {
    alleStarten();
  }
  // Im Theme-Editor wird eine Sektion neu gerendert.
  document.addEventListener('shopify:section:load', alleStarten);
})();
